import { Segment } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Segment/Segment';
import { SegmentType } from '@goldcast/player-config/src/types/Segment/Type';

const getSegmentsBetweenIds = (allSegments: Segment[], startSegmentId: string, endSegmentId: string): Segment[] => {
  const startSegmentIndex = allSegments.findIndex(segment => segment.id === startSegmentId);
  const endSegmentIndex = allSegments.findIndex(segment => segment.id === endSegmentId);

  if (startSegmentIndex === -1 || endSegmentIndex === -1) {
    return [];
  }

  const rangeStart = Math.min(startSegmentIndex, endSegmentIndex);
  const rangeEnd = Math.max(startSegmentIndex, endSegmentIndex);
  return allSegments.slice(rangeStart, rangeEnd + 1);
};

export const hasCompositeSegmentInFrameRange = (allSegments: Segment[], startFrame: number, endFrame: number) => {
  const rangeStart = Math.min(startFrame, endFrame);
  const rangeEnd = Math.max(startFrame, endFrame);

  return allSegments.some(
    segment => segment.type === SegmentType.COMPOSITE && segment.fromFrame < rangeEnd && rangeStart < segment.toFrame
  );
};

export const hasCompositeSegmentBetweenSegmentIds = (
  allSegments: Segment[],
  startSegmentId: string,
  endSegmentId: string
) => {
  const segmentsBetween = getSegmentsBetweenIds(allSegments, startSegmentId, endSegmentId);
  return segmentsBetween.some(segment => segment.type === SegmentType.COMPOSITE);
};

export const hasCreatableCompositeSegmentBetweenSegmentIds = ({
  allSegments,
  startSegmentId,
  endSegmentId,
  endSegmentTime,
  minVideoSegmentDuration
}: {
  allSegments: Segment[];
  startSegmentId: string;
  endSegmentId: string;
  endSegmentTime?: number;
  minVideoSegmentDuration: number;
}) => {
  const segmentsBetween = getSegmentsBetweenIds(allSegments, startSegmentId, endSegmentId);

  const compositeSegmentCount = segmentsBetween.filter(segment => segment.type === SegmentType.COMPOSITE).length;
  if (compositeSegmentCount > 1) {
    return true;
  }

  if (endSegmentTime === undefined) {
    return false;
  }

  return segmentsBetween.some(segment => {
    if (segment.type !== SegmentType.COMPOSITE || segment.segment_metadata?.start === undefined) {
      return false;
    }
    return endSegmentTime - segment.segment_metadata.start > minVideoSegmentDuration;
  });
};
